module.exports = __webpack_public_path__ + "img/draw2_img4.ba41f9c8.png";